<template>
  <div>
    <div class="widget-header col-md-12" v-if="filter && search">
      <vuestic-tag-group :value="search" :option="option" :listDefinition="listDefinition" :removeFunction="removeFunction" removable/>
    </div>
    <div class="widget-header col-md-12">
      <div class="col">
        <span v-if="showHeader">{{listDefinition.title}}</span>
        <img src="static/icons/actions/edit-32.png" style="cursor: pointer; height: 1.3em; margin-left: 0.1em;" v-if="multiSelectCount > 0" @click="buttonMultiEdit" />
        <img src="static/icons/actions/trash-32.png" style="cursor: pointer; height: 1.3em; margin-left: 0.1em;" v-if="multiSelectCount > 0" @click="buttonMultiDelete" />
        <img src="static/icons/actions/add-32.png" slot="trigger" v-tooltip="`Add New ${listDefinition.title}`" style="cursor: pointer; height: 1.1em; margin-left: 0.1em;" v-if="showHeader && button && multiSelectCount === 0 && policy.can('add')" @click="buttonAction" />
      </div>
      <div class="text-right" v-if="$mq !== 'mobile'">
        <span class="clear-filter" @click="clearAll" v-if="filter">Clear filters</span><span v-if="filter && download.length > 0 && listDefinition.csv"> | </span>
        <download-csv
        	class   = "clear-filter"
        	:data   = "download"
        	:name    = "`${listDefinition.title}.csv`"
          v-if="download.length > 0 && listDefinition.csv">

        	Download as CSV

        </download-csv>
      </div>
      <div class="text-right" v-else>
        <span class="clear-filter" @click="clearAll" v-if="filter">Clear filters</span><span v-if="filter && download.length > 0 && listDefinition.csv"> | </span>
        <download-csv
        	class   = "clear-filter"
        	:data   = "download"
        	:name    = "`${listDefinition.title}.csv`"
          v-if="download.length > 0 && listDefinition.csv">

        	<i class="glyphicon glyphicon-download-alt" />

        </download-csv>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import JsonCSV from 'vue-json-csv'
  import Moment from 'moment-timezone'

  Vue.component('downloadCsv', JsonCSV)

  export default {
    name: 'table-header',
    props: {
      multiSelectCount: {
        type: Number
      },
      buttonMultiEdit: {
        type: Function
      },
      buttonMultiDelete: {
        type: Function
      },
      button: {
        type: Boolean
      },
      buttonAction: {
        type: Function
      },
      clearAll: {
        type: Function
      },
      listDefinition: {
        type: Object,
        default: () => {}
      },
      csvDefinition: {
        type: Object,
        default: () => {}
      },
      filter: {
        type: Boolean
      },
      filteredData: {
        type: Array
      },
      search: {
        type: Array
      },
      option: {
        type: Array
      },
      removeFunction: {
        type: Function
      },
      policy: {
        type: Function
      },
      showHeader: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      download () {
        var self = this
        var data = []
        if (self.listDefinition.csv) {
          self.filteredData.forEach((object) => {
            var temp = {}
            const tz = Moment.tz.guess()
            self.csvDefinition.tableFields.forEach(async (field) => {
              temp[field.title] = _.get(object, field.key)

              if (field.type === 'date' && temp[field.title]) {
                temp[field.title] = Moment(String(temp[field.title])).tz(tz).format('MM/DD/YY HH:mm:ss') + ` (${tz})`
              }
            })
            data.push(temp)
          })
        }
        return data
      }
    },
    methods: {
    }
  }
</script>
<style lang="scss">
  @import "../../../../sass/variables";

  .clear-filter:hover {
    color: $fractel-teal;
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/objects/table/Header.vue